<template>
  <div class="nav-container">
    <h4 class="answer-count">
      {{ Object.keys(this.$store.state.answers).length - 2 + "/" + this.$store.state.count }}
    </h4>
    <div v-for="(domain, i) in data" :key="i" class="domain-list">
      <div @click="updateDomain(i, true)">
        <div v-if="this.$store.state.navState[domain.category] === 1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-check2-circle" viewBox="0 0 16 16">
            <path
                d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/>
            <path
                d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>
          </svg>
        </div>
        <div v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle"
               viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          </svg>
        </div>
      </div>
      <div @click="updateDomain(i, true)" :class="domain.category === currentCategory ? 'active-domain' : ''">
        {{ domain.category }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "NavContainer",
  props: {
    data: {},
    currentCategory: null
  },
  data() {
    return {
      navState: []

    };
  },
  watch: {},
  methods: {
    updateDomain(index, chapter) {
      this.$emit("updateDomain", index, chapter);
    },
  },
  mounted() {
  },
}
</script>
<style scoped lang="scss">
.nav-container {
  background-color: rgba(170, 216, 231, 0.849);
  padding: 1rem;
  height: 350px;
  cursor: pointer;
  position: fixed;
  margin-left: 30px;
  width: 140px;
  z-index: 2000;
}

.domain-list {
  display: flex;
  gap: 10px;
  font-size: 1.2rem;
  align-items: center;
}

.active-domain {
  font-weight: 900;
  font-size: 1.4rem;
}

</style>
